import { AnimatePresence, motion } from 'framer-motion'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import React, { Suspense } from 'react'

import AuthInit from './modules/auth/redux/AuthInit';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { Routes } from './routing/Routes'

// @mui material components

type Props = {}

const App: React.FC<Props> = () => {
  return (
    <AnimatePresence>
      <Suspense fallback={<LayoutSplashScreen />}>
        <BrowserRouter>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Routes />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </BrowserRouter>
      </Suspense>
    </AnimatePresence>
  )
}

export { App }
